'use strict';

GlobalSettingsRepository.$inject = ["refDataApiFactory"];
var _ = require('lodash');

function GlobalSettingsRepository(refDataApiFactory) {
  var that = this;

  that.get = function () {
    return refDataApiFactory.create().then(function (refDataApi) {
      return refDataApi.one('profile').get()
          .then(function (profile) {
            return profile.globalSettings;
          });
    });
  };

  that.save = function (globalSettings) {
    return refDataApiFactory.create().then(function (refDataApi) {
      return refDataApi.one('profile')
          .customPUT(globalSettings, 'globalSettings');
    });
  };

  function getDoNotAskFlagPath(id) {
    return 'doNotAskFlags[' + id + ']';
  }

  that.getDoNotAskFlag = function (id) {
    return that.get().then(function (globalSettings) {
      return !!_.get(globalSettings, getDoNotAskFlagPath(id));
    });
  };

  that.setDoNotAskFlag = function (id, flag) {
    var globalSettings = {};
    _.set(globalSettings, getDoNotAskFlagPath(id), flag);
    return that.save(globalSettings);
  };

  that.isEnabledMiFIDFieldsForEuropeanProducts = function () {
    return that.get().then(function (globalSettings) {
      return !!globalSettings.enableMiFIDFieldsForEuropeanProducts;
    });
  }
}

module.exports = /* @ngInject */ GlobalSettingsRepository;



//////////////////
// WEBPACK FOOTER
// /app/~/redi-refdata-web-lib/dist/business/globalSettingsRepository.js
// module id = 129
// module chunks = 0